import { render, staticRenderFns } from "./InvoiceManagement.vue?vue&type=template&id=0b176817&scoped=true"
import script from "./InvoiceManagement.vue?vue&type=script&lang=ts"
export * from "./InvoiceManagement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b176817",
  null
  
)

export default component.exports